/**
 * \@file formsId.js
 * \@description This file exports an array of form IDs used in the patient context.
 * Each form ID object contains an `id` and a boolean `isMiniForm` indicating whether it is a mini form.
 * This structure is necessary to avoid circular dependencies.
 */
export const formIds = [
    { id: 'ecds', isMiniForm: false },
    { id: 'clerkingED', isMiniForm: false },
    { id: 'triage', isMiniForm: false },
    { id: 'snt', isMiniForm: false },
    { id: 'vte', isMiniForm: false },
    { id: 'msgToGp', isMiniForm: false },
    { id: 'injury', isMiniForm: false },
    { id: 'frailtyHistory', isMiniForm: false },
    { id: 'aeAssessment', isMiniForm: false },
    { id: 'safetyChecklist', isMiniForm: false },
    { id: 'propertyList', isMiniForm: false },
    { id: 'vod', isMiniForm: false },
    { id: 'referralReview', isMiniForm: false },
    { id: 'specReferrals', isMiniForm: false },
    { id: 'fallsAmb', isMiniForm: false },
    { id: 'cardiacStrokeAmb', isMiniForm: false },
    { id: 'airwaysManagementAmb', isMiniForm: false },
    { id: 'newBedRequest', isMiniForm: false },
    { id: 'bedRequest', isMiniForm: false },
    { id: 'urinalysis', isMiniForm: false, isAddData: true },
    { id: 'household', isMiniForm: false, isAddData: true },
    { id: 'paedSafeguarding', isMiniForm: false },
    { id: 'delirium', isMiniForm: false },
    { id: 'clinicalFrailtyScore', isMiniForm: false },
    { id: 'prescription', isMiniForm: false },
    { id: 'prescriptionExternal', isMiniForm: false },
    { id: 'fitnessForWork', isMiniForm: false },
    { id: 'sepsisTool', isMiniForm: false, isAddData: true },
    { id: 'nutritionScreen', isMiniForm: false, isAddData: true },
    { id: 'edauDischarge', isMiniForm: false },
    { id: 'discharge', isMiniForm: false },
    { id: 'obs', isMiniForm: false },
    { id: 'neuroObs', isMiniForm: false },
    { id: 'mewsObs', isMiniForm: false },
    { id: 'boardRound', isMiniForm: false },
    { id: 'clerkingIP', isMiniForm: false },
    { id: 'ecdsEmail', isMiniForm: true },
    { id: 'clinicalConclusion', isMiniForm: true },
    { id: 'smoking', isMiniForm: true },
    { id: 'auditC', isMiniForm: false },
    { id: 'rapidAssessment', isMiniForm: true },
    { id: 'dependency', isMiniForm: true },
    { id: 'treatmentPlan', isMiniForm: true },
    { id: 'medicalPlan', isMiniForm: true },
    { id: 'nursingPlan', isMiniForm: true },
    { id: 'nursingChecklist', isMiniForm: true },
    { id: 'medicalChecklist', isMiniForm: true },
    { id: 'currentClinician', isMiniForm: true },
    { id: 'firstClinician', isMiniForm: true },
    { id: 'currentNurse', isMiniForm: true },
    { id: 'ambulanceHandover', isMiniForm: true },
    { id: 'seniorReview', isMiniForm: true },
    { id: 'handover', isMiniForm: true },
    { id: 'nurseHandover', isMiniForm: true },
    { id: 'csm', isMiniForm: true },
    { id: 'offWard', isMiniForm: true },
    { id: 'intendentManagement', isMiniForm: true },
    { id: 'currentNurseIP', isMiniForm: true },
    { id: 'currentClinicianIP', isMiniForm: true },
    { id: 'oxygen', isMiniForm: true },
    { id: 'frailtySDECForm', isMiniForm: false },
    { id: 'abbeyPainScaleForm', isMiniForm: false },
    { id: 'abbeyPainScaleFormObs', isMiniForm: false },
    { id: 'customNote', isMiniForm: true },
    { id: 'initialAssessment', isMiniForm: true },
];
